import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { first, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { KycComponent } from '../kyc/kyc.component';
import { OtpverificationComponent } from '../otpverification/otpverification.component';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CommonService } from '../../../_common/_service/user.service';


@Component({
  selector: 'app-merchantapi',
  templateUrl: './merchantapi.component.html',
  styleUrls: ['./merchantapi.component.scss']
})

export class MerchantapiComponent implements OnInit {
 
 
  currentUser: any;
    username: any;
    password: any;

  constructor(private toastr: ToastrService, private tokenStorageService: TokenStorageService, public dialog: MatDialog,
    private authService: AuthService, public dialogRef: MatDialogRef<MerchantapiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
   
  }

  ngOnInit() {    
    this.currentUser = this.tokenStorageService.getUser();
    this.getMerchantapi();
  }

  getMerchantapi() {
    this.authService.getMerchantapi().subscribe(response => {
      debugger;
      if (response.apiStatus== true) {
        this.username = response.apiData.username;
        this.password = response.apiData.password;
      }
      else if (response.apiStatus == false) {
        
        this.toastr.error(response.apiMessage, 'Error');
      }
      else {
        this.toastr.error('Error', 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    });
  }




}


